module.exports = __webpack_public_path__ + "static/media/pbImage.b79c6cc6.png";